export const GENDER_FIELD_ID = 'gender'

export type GenderQuestionMode = 'id_marker' | 'self_id'

export const GENDER_QUESTION_MODE_ID_MARKER: GenderQuestionMode = 'id_marker'
export const GENDER_QUESTION_MODE_SELF_ID: GenderQuestionMode = 'self_id'

export type GenderValue = 'male' | 'female' | 'nonbinary' | 'prefer_not_to_say'

export const GENDER_QUESTION_BY_MODE: Record<
    GenderQuestionMode,
    { question_text: string; options: string[]; helper_text: string }
> = {
    id_marker: {
        question_text:
            'What is your gender as it appears on a government-issued ID?',
        options: ['Male (M)', 'Female (F)', 'Nonbinary (X)'],
        helper_text:
            "Choose the marker printed on your driver's license, state ID, or passport. California IDs use M, F, or X.",
    },
    self_id: {
        question_text: 'What is your gender identity?',
        options: ['Male', 'Female', 'Non-binary', 'Prefer not to say'],
        helper_text:
            'Select the option that best describes your gender identity.',
    },
}

const GENDER_VALUE_ALIASES: Record<string, GenderValue> = {
    male: 'male',
    m: 'male',
    'male (m)': 'male',
    man: 'male',
    female: 'female',
    f: 'female',
    'female (f)': 'female',
    woman: 'female',
    nonbinary: 'nonbinary',
    'non-binary': 'nonbinary',
    'non binary': 'nonbinary',
    x: 'nonbinary',
    'nonbinary (x)': 'nonbinary',
    'prefer not to say': 'prefer_not_to_say',
    prefer_not_to_say: 'prefer_not_to_say',
}

const GENDER_LABELS: Record<GenderValue, string> = {
    male: 'Male',
    female: 'Female',
    nonbinary: 'Non-binary',
    prefer_not_to_say: 'Prefer not to say',
}

export function normalizeGenderQuestionMode(raw: unknown): GenderQuestionMode {
    const text = String(raw || '')
        .trim()
        .toLowerCase()
    if (text === GENDER_QUESTION_MODE_SELF_ID)
        return GENDER_QUESTION_MODE_SELF_ID
    return GENDER_QUESTION_MODE_ID_MARKER
}

export function genderQuestionSpec(mode?: unknown) {
    const normalized = normalizeGenderQuestionMode(mode)
    const spec = GENDER_QUESTION_BY_MODE[normalized]
    return {
        gender_question_mode: normalized,
        question_text: spec.question_text,
        options: [...spec.options],
        helper_text: spec.helper_text,
    }
}

export function normalizeGenderValue(raw: unknown): GenderValue | null {
    const text = String(raw || '')
        .trim()
        .toLowerCase()
    if (!text) return null
    return GENDER_VALUE_ALIASES[text] ?? null
}

export function genderDisplayLabel(raw: unknown): string {
    const value = normalizeGenderValue(raw)
    if (!value) return '—'
    return GENDER_LABELS[value]
}
